import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useMouseScrubVideo } from './useMouseScrubVideo';
import { useCopy } from './copy/copyMode';
import { WaitlistCTA } from './WaitlistCTA';
export function ClosingCTA() {
  const copy = useCopy();
  const videoRef = useMouseScrubVideo<HTMLVideoElement>();
  return <section className="relative w-full overflow-hidden bg-[#2B211A] min-h-[500px] lg:min-h-[640px] flex items-center py-20 lg:py-0" data-id="element-651">
      {/* Background Video — hidden on mobile, where the section is just a solid
                      brown background for a cleaner, faster read. */}
      <video ref={videoRef} src="https://cdn.magicpatterns.com/uploads/2KeMkbTqjm2CZVnGJapvba/hf_20260619_223334_50388977-efc1-401a-95ea-f11fa2ea2644.mp4" muted playsInline preload="auto" className="hidden md:block absolute inset-0 w-full h-full object-cover object-[75%_center] md:object-center" data-id="element-652" />

      {/* Subtle overlays — desktop only (mobile is solid brown). */}
      <div className="hidden md:block absolute inset-0 bg-black/20 pointer-events-none" data-id="element-653" />
      <div className="hidden md:block absolute inset-0 bg-gradient-to-r from-[#2B211A]/80 via-transparent to-transparent pointer-events-none" data-id="element-654" />

      <div className="max-w-[1280px] mx-auto px-6 md:px-10 relative z-10 w-full" data-id="element-655">
        <div className="lg:w-1/2 lg:pr-12 flex flex-col items-start text-left lg:items-start lg:text-left" data-id="element-656">
          <motion.h2 initial={{
          opacity: 0,
          y: 8
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          ease: [0.22, 1, 0.36, 1]
        }} className="font-title font-medium text-4xl md:text-6xl lg:text-7xl tracking-tight text-white leading-[1.05]" data-id="element-657">
            {copy.closingCta.headline}
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 8
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: 0.06,
          ease: [0.22, 1, 0.36, 1]
        }} className="mt-5 md:mt-7 text-base md:text-xl text-white/80 max-w-lg leading-relaxed" data-id="element-658">
            Lives in Slack or Teams. Set up in 2 minutes, free for 7 days. By
            tomorrow, the busywork is already done.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 8
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: 0.12,
          ease: [0.22, 1, 0.36, 1]
        }} className="mt-7 md:mt-9 flex flex-col items-start gap-4" data-id="element-659">
            <WaitlistCTA className="bg-[#EA580C] hover:bg-[#C2410C] text-white px-9 py-4 rounded-full font-bold text-lg transition-colors shadow-[0_0_30px_rgba(234,88,12,0.4)]" data-id="element-660">
              Try Giga for free
            </WaitlistCTA>
            <p className="text-sm text-white/80 font-medium" data-id="element-661">
              7-day free trial · Cancel anytime
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}